/**
 * Send Email manifest — `send-email` action.
 *
 * Walks any source → contact (must have email). Opens the compose-email
 * modal with resolved contact(s) pre-loaded as recipients.
 *
 * From a company (or any path whose terminal hop is company → contacts):
 * auto-selects all contacts with email — no pick/confirm steps.
 *
 * From a deal: walks deal → company → contact (user picks recipient(s)).
 */

import { registerActionManifest } from "./registry";
import { openComposeEmailModal } from "./helpers/openComposeEmail";

registerActionManifest({
  actionId: "send-email",
  label: "Send email",
  primaryEntity: "contact",
  mode: "client-redirect",
  requires: {
    entity: "contact",
    requiredFields: ["email"],
    allowMulti: true,
    bulkMax: 50,
    autoSelectAllTerminal: true,
  },
  clientRun: async (resolved, hooks) => {
    await openComposeEmailModal(resolved, hooks);
  },
});
